import { render, staticRenderFns } from "./stockForm.vue?vue&type=template&id=9c97ca32&scoped=true&"
import script from "./stockForm.vue?vue&type=script&lang=js&"
export * from "./stockForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c97ca32",
  null
  
)

export default component.exports